/* =========================================================
   KAYO – Panier version D : bouton + des vignettes « Complète ton look »
   - produit à une seule variante : le + ajoute directement (géré par kayo-cart.js)
   - plusieurs tailles : le + ouvre le choix de la taille sur la photo,
     un clic sur une taille ajoute cette taille au panier.
   ========================================================= */
(function () {
  if (window.kayoCartD) return;
  window.kayoCartD = true;

  function closeAll(root, except) {
    root.querySelectorAll('.kayo-upsell__sizes').forEach(function (b) { if (b !== except) b.hidden = true; });
    root.querySelectorAll('[data-kayo-pick]').forEach(function (b) {
      if (except && b.closest('[data-kayo-upsell-card]').contains(except)) return;
      b.setAttribute('aria-expanded', 'false');
      b.classList.remove('is-open');
    });
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-kayo-pick]');
    if (pick) {
      var card = pick.closest('[data-kayo-upsell-card]');
      var sizes = card && card.querySelector('.kayo-upsell__sizes');
      if (!sizes) return;
      var open = sizes.hidden;
      closeAll(document, open ? sizes : null);
      sizes.hidden = !open;
      pick.setAttribute('aria-expanded', open ? 'true' : 'false');
      pick.classList.toggle('is-open', open);
      return;
    }
    var size = e.target.closest('.kayo-upsell__size');
    if (size) {
      var form = size.closest('form[data-kayo-upsell-form]');
      var input = form && form.querySelector('input[name="id"]');
      if (input) input.value = size.dataset.variant;
    }
  }, true);
})();
